var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EmployeesList m-grid m-grid--hor m-grid--root m-page"},[_c('div',{staticClass:"m-grid__item m-grid__item--fluid m-wrapper"},[_c('ListEmployees')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }